import React from 'react';
import styled from 'styled-components/macro';
import Sentiments from '../Sentiments';
import BarElement from './BarElement';
import { LocaleType } from '../utils/getTranslations';
import { LabelType } from '../Bar/Bar';

const Chart = styled.div`
  width: 100%;
  display: flex;
  overflow: visible;
`;

export interface ElementType {
  value: number;
  label: LabelType;
  color?: string;
  sentiment: string;
  sentimentMap?: null | LabelType;
  labels?: any;
}

interface StackedBarChartPropsType {
  data: any;
  locale: LocaleType;
  name?: string | LabelType;
}
const formatAggregatedDataForChart = (data: ElementType[]) => {
  const formattedData: ElementType[] = [];

  formattedData.push({
    value: data[0].value,
    color: Sentiments.get(parseInt(data[0].sentiment)).color,
    sentiment: data[0].sentiment,
    sentimentMap: data[0].sentimentMap,
    label: {},
  });

  for (let i = 1; i < data.length; i++) {
    if (
      formattedData[formattedData.length - 1].sentiment === data[i].sentiment
    ) {
      formattedData[formattedData.length - 1].labels.push(data[i].label);
      formattedData[formattedData.length - 1].value += data[i].value;
    } else {
      formattedData.push({
        value: data[i].value,
        color: Sentiments.get(parseInt(data[i].sentiment)).color,
        sentiment: data[i].sentiment,
        sentimentMap: data[i].sentimentMap,
        label: {},
      });
    }
  }

  return formattedData;
};

export const formatDataForChart = (data: ElementType[]) => {
  let formattedData: ElementType[] = [];

  if (data[0].sentimentMap) {
    formattedData = formatAggregatedDataForChart(data);
  } else {
    for (const element of data) {
      formattedData.push({
        value: element.value,
        label: element.label,
        color: Sentiments.get(parseInt(element.sentiment)).color,
        sentiment: element.sentiment,
      });
    }
  }

  formattedData.sort(
    (a: ElementType, b: ElementType) =>
      Number(a.sentiment) - Number(b.sentiment)
  );

  return formattedData;
};

const StackedBarChart = ({ data, locale }: StackedBarChartPropsType) => {
  const formattedData = formatDataForChart(data);

  return (
    <Chart>
      {formattedData.map((element: ElementType, idx: number) => {
        let position = 'first';
        idx > 0
          ? idx === formattedData.length - 1
            ? (position = 'last')
            : (position = '')
          : (position = 'first');
        return (
          <BarElement
            key={idx}
            element={element}
            position={position}
            locale={locale}
          />
        );
      })}
    </Chart>
  );
};

export default StackedBarChart;
